export const A = 65;
export const ArrowDown = 40;
export const ArrowLeft = 37;
export const ArrowRight = 39;
export const ArrowUp = 38;
export const B = 66;
export const Backspace = 8;
export const C = 67;
export const D = 68;
export const Delete = 46;
export const E = 69;
export const End = 35;
export const Enter = 13;
export const Esc = 27;
export const F = 70;
export const F1 = 112;
export const F10 = 121;
export const F11 = 122;
export const F12 = 123;
export const F2 = 113;
export const F3 = 114;
export const F4 = 115;
export const F5 = 116;
export const F6 = 117;
export const F7 = 118;
export const F8 = 119;
export const F9 = 120;
export const G = 71;
export const H = 72;
export const Home = 36;
export const I = 73;
export const Insert = 45;
export const J = 74;
export const K = 75;
export const L = 76;
export const M = 77;
export const N = 78;
export const O = 79;
export const P = 80;
export const PageDown = 34;
export const PageUp = 33;
export const Q = 81;
export const R = 82;
export const S = 83;
export const T = 84;
export const U = 85;
export const V = 86;
export const W = 87;
export const X = 88;
export const Y = 89;
export const Z = 90;
